import { GOOGLE_MAPS_SERVICE_ID, GOOGLE_SDK_LINK, GOOGLE_SDK_SCRIPT_ID } from 'constants/google';
import { decodeBase64Object } from './authentication';
import { loadScript } from './script';
let googleApiLoadedCallbacks = [];

const callGoogleApiCallbacks = () => {
  googleApiLoadedCallbacks.forEach(callback => callback());
};

const onGoogleCallback = onGoogleApiLoaded => {
  var _window$google;

  window.googleApiLoaded = callGoogleApiCallbacks;

  if (!googleApiLoadedCallbacks.includes(onGoogleApiLoaded)) {
    googleApiLoadedCallbacks.push(onGoogleApiLoaded);
  }

  if (!((_window$google = window.google) !== null && _window$google !== void 0 && _window$google.maps)) return;
  callGoogleApiCallbacks();
};

export const loadGoogleApi = _ref => {
  let {
    apiKey,
    onGoogleApiLoaded
  } = _ref;
  onGoogleCallback(onGoogleApiLoaded);

  if (document.getElementById(GOOGLE_MAPS_SERVICE_ID)) {
    return;
  }

  const url = new URL('/maps/api/js', 'https://maps.googleapis.com');
  url.searchParams.set('key', apiKey);
  url.searchParams.set('libraries', ['places', 'geometry'].toString());
  url.searchParams.set('callback', 'googleApiLoaded');
  const src = url.toString();
  loadScript({
    id: GOOGLE_MAPS_SERVICE_ID,
    src
  });
};
export const loadGoogleSdk = () => {
  return loadScript({
    id: GOOGLE_SDK_SCRIPT_ID,
    isAsync: true,
    src: GOOGLE_SDK_LINK
  });
};
export const removeGoogleCallback = callback => {
  googleApiLoadedCallbacks = googleApiLoadedCallbacks.filter(loadedCallback => loadedCallback !== callback);
};
export const getGoogleRedirectUrl = state => {
  const decodedState = decodeBase64Object(state);
  return (decodedState === null || decodedState === void 0 ? void 0 : decodedState.redirect_uri) || state;
};